/* Bandeau de suggestion de langue ABN. Pas de redirection : le visiteur choisit. */
(function () {
  var tag = document.getElementById('abn-lang-suggest-js');
  if (!tag) return;

  var TEXTS = {
    fr: { msg: 'Préférez-vous consulter la boutique en français ?', go: 'Passer au français', no: 'Non merci', close: 'Fermer', label: 'Choix de la langue' },
    de: { msg: 'Möchtest du den Shop lieber auf Deutsch sehen?', go: 'Zu Deutsch wechseln', no: 'Nein danke', close: 'Schließen', label: 'Sprachauswahl' },
    es: { msg: '¿Prefieres ver la tienda en español?', go: 'Ver en español', no: 'No, gracias', close: 'Cerrar', label: 'Selección de idioma' },
    it: { msg: 'Preferisci vedere il negozio in italiano?', go: "Passa all'italiano", no: 'No, grazie', close: 'Chiudi', label: 'Scelta della lingua' },
    ja: { msg: 'ショップを日本語で見ますか？', go: '日本語に切り替える', no: 'いいえ結構です', close: '閉じる', label: '言語選択' },
    ko: { msg: '스토어를 한국어로 보시겠습니까?', go: '한국어로 전환', no: '아니요, 괜찮습니다', close: '닫기', label: '언어 선택' },
    'zh-tw': { msg: '您想以繁體中文瀏覽商店嗎？', go: '切換至繁體中文', no: '不用了，謝謝', close: '關閉', label: '語言選擇' },
    pl: { msg: 'Czy wolisz przeglądać sklep w języku polskim?', go: 'Przełącz na polski', no: 'Nie, dziękuję', close: 'Zamknij', label: 'Wybór języka' },
    sv: { msg: 'Vill du hellre se butiken på svenska?', go: 'Byt till svenska', no: 'Nej tack', close: 'Stäng', label: 'Val av språk' },
    nb: { msg: 'Vil du heller se butikken på norsk?', go: 'Bytt til norsk', no: 'Nei takk', close: 'Lukk', label: 'Språkvalg' },
    lt: { msg: 'Ar norėtumėte peržiūrėti parduotuvę lietuviškai?', go: 'Perjungti į lietuvių kalbą', no: 'Ne, ačiū', close: 'Uždaryti', label: 'Kalbos pasirinkimas' }
  };
  var KEY = 'abn_lang_suggest_off';
  var DAYS = 90;

  var current = (tag.getAttribute('data-current') || '').toLowerCase();
  var roots = {};
  (tag.getAttribute('data-langs') || '').split(',').forEach(function (pair) {
    var p = pair.split('|');
    if (p[0] && p[1]) roots[p[0].toLowerCase()] = p[1];
  });

  function dismissed() {
    try {
      var v = window.localStorage.getItem(KEY);
      if (v && Date.now() - parseInt(v, 10) < DAYS * 864e5) return true;
    } catch (e) {}
    return document.cookie.split('; ').some(function (c) { return c.indexOf(KEY + '=') === 0; });
  }

  function remember() {
    try { window.localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
    document.cookie = KEY + '=1; path=/; max-age=' + DAYS * 86400 + '; SameSite=Lax';
  }

  function pickLanguage() {
    var list = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || ''];
    for (var i = 0; i < list.length; i++) {
      var raw = String(list[i]).toLowerCase();
      if (!raw) continue;
      var primary = raw.split('-')[0];
      // Teste d'abord le tag complet (ex: zh-tw), sinon la sous-etiquette principale (ex: fr).
      var code = roots[raw] ? raw : (roots[primary] ? primary : null);
      if (!code) continue;
      // La premiere langue du navigateur que la boutique publie decide. Si c'est la langue affichee, on se tait.
      return code === current ? null : (TEXTS[code] ? code : null);
    }
    return null;
  }

  function targetUrl(code) {
    var path = window.location.pathname;
    var curRoot = roots[current] || '/';
    if (curRoot !== '/' && (path === curRoot || path.indexOf(curRoot + '/') === 0)) {
      path = path.slice(curRoot.length) || '/';
    }
    var root = roots[code];
    var full = root === '/' ? path : (path === '/' ? root : root + path);
    return full + window.location.search + window.location.hash;
  }

  function build(code) {
    var t = TEXTS[code];
    var css = document.createElement('style');
    css.textContent =
      '#abn-lang-suggest{position:fixed;left:0;right:0;top:0;z-index:100000;background:#fff;color:#3a1f2b;' +
      'border-bottom:2px solid #85284a;box-shadow:0 4px 18px rgba(0,0,0,.12);font-size:15px;line-height:1.4;' +
      'transform:translateY(-110%);transition:transform .25s ease-out}' +
      '#abn-lang-suggest.is-open{transform:none}' +
      '#abn-lang-suggest .abn-ls-in{max-width:1100px;margin:0 auto;padding:10px 48px 10px 16px;display:flex;flex-wrap:wrap;align-items:center;gap:8px 14px}' +
      '#abn-lang-suggest p{margin:0;flex:1 1 220px}' +
      '#abn-lang-suggest a,#abn-lang-suggest button{font:inherit;cursor:pointer;border-radius:4px;min-height:44px}' +
      '#abn-lang-suggest .abn-ls-go{background:#85284a;color:#fff;text-decoration:none;padding:9px 16px;display:inline-flex;align-items:center}' +
      '#abn-lang-suggest .abn-ls-no{background:none;border:1px solid #85284a;color:#85284a;padding:8px 14px}' +
      '#abn-lang-suggest .abn-ls-x{position:absolute;top:4px;right:4px;width:44px;height:44px;background:none;border:0;color:#3a1f2b;font-size:24px;line-height:1}' +
      '#abn-lang-suggest a:focus-visible,#abn-lang-suggest button:focus-visible{outline:3px solid #1a73e8;outline-offset:2px}' +
      '@media (max-width:749px){#abn-lang-suggest{font-size:14px}#abn-lang-suggest .abn-ls-in{padding:6px 48px 6px 12px;gap:6px 10px}#abn-lang-suggest p{flex-basis:100%}}' +
      '@media (prefers-reduced-motion:reduce){#abn-lang-suggest{transition:none}}';
    document.head.appendChild(css);

    var box = document.createElement('div');
    box.id = 'abn-lang-suggest';
    box.setAttribute('role', 'region');
    box.setAttribute('aria-label', t.label);
    box.setAttribute('lang', code);
    box.innerHTML =
      '<div class="abn-ls-in"><p></p>' +
      '<a class="abn-ls-go" hreflang="' + code + '"></a>' +
      '<button type="button" class="abn-ls-no"></button>' +
      '<button type="button" class="abn-ls-x"><span aria-hidden="true">&times;</span></button></div>';
    box.querySelector('p').textContent = t.msg;
    var go = box.querySelector('.abn-ls-go');
    go.textContent = t.go;
    go.href = targetUrl(code);
    box.querySelector('.abn-ls-no').textContent = t.no;
    box.querySelector('.abn-ls-x').setAttribute('aria-label', t.close);

    function close() {
      remember();
      box.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { if (box.parentNode) box.parentNode.removeChild(box); }, 300);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    box.querySelector('.abn-ls-no').addEventListener('click', close);
    box.querySelector('.abn-ls-x').addEventListener('click', close);
    document.addEventListener('keydown', onKey);

    document.body.insertBefore(box, document.body.firstChild);
    requestAnimationFrame(function () { requestAnimationFrame(function () { box.classList.add('is-open'); }); });
  }

  // Une seule apparition par session : ignore une fois, le bandeau ne suit plus le visiteur de page en page.
  var SEEN = 'abn_lang_suggest_seen';
  function seenThisSession() {
    try { return window.sessionStorage.getItem(SEEN) === '1'; } catch (e) { return false; }
  }

  // Le bandeau cookies passe d'abord : deux bandeaux a la fois, le visiteur ferme les deux sans lire.
  function consentPending() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || !cp.shouldShowBanner || !cp.shouldShowBanner()) return false;
    var c = cp.currentVisitorConsent ? cp.currentVisitorConsent() : null;
    if (!c) return false;
    for (var k in c) { if (c[k] !== '') return false; }
    return true;
  }

  function show() {
    if (dismissed() || seenThisSession()) return;
    var code = pickLanguage();
    if (!code) return;
    try { window.sessionStorage.setItem(SEEN, '1'); } catch (e) {}
    build(code);
  }

  function init() {
    if (dismissed() || seenThisSession() || !pickLanguage()) return;
    var tries = 0;
    (function wait() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp && tries++ < 15) return setTimeout(wait, 200);
      if (!consentPending()) return show();
      document.addEventListener('visitorConsentCollected', function () { setTimeout(show, 500); }, { once: true });
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
